import { Client, DataFromUrl, goToNextPage, handleOtherResponseCode, REDIRECT, SUCCESS_REPONSE_CODE, toastr,
         UNPROCESSABLE_ENTITY_RESPONSE_CODE, CustomToastrAction, CONSTANTS } from  '@/imports-files/pages/admins/dashboard/clients/new';
import router from 'next/router';



export function nextStep(setButtonPopup, link, router)
{
    router.push(link)
    setButtonPopup(false);
}


function isItUpdateAction()
{
  const client_id              =   new DataFromUrl().getClientId();
  return client_id ? true : false
}

export class AdminClientNewAction
{

  constructor(setApiError, formRef, setFlagForRender, selectedBrandLogo, selectedEmailLogo, selectedSidebarLogo)
  {
    this.setApiError              =   setApiError;
    this.customToastrAction       =   new CustomToastrAction();
    this.formRef                  =   formRef;
    this.setFlagForRender         =   setFlagForRender;
    this.selectedBrandLogo        =   selectedBrandLogo;
    this.selectedEmailLogo        =   selectedEmailLogo;
    this.selectedSidebarLogo      =   selectedSidebarLogo;
  }

    async selectFile(selectedFile, setSelectedFile, type)
    {
        let preview_container_id = null;
        let image_height = null;
        let image_width = null ;
        let drop_down_container = null;
        let field_name = null;
        if(type=='brand_logo')
        {
          preview_container_id = 'brand_logo_preview';
          image_height = CONSTANTS.brand_logo.file_height;
          image_width = CONSTANTS.brand_logo.file_width;
          drop_down_container = 'brand_logo_preview_drag_drop';
          field_name = 'client.client_branding_attributes.logo';
        }
        else if(type=='sidebar_logo')
        {
          preview_container_id = 'sidebar_logo_preview';
          image_height = CONSTANTS.sidebar_logo.file_height;
          image_width = CONSTANTS.sidebar_logo.file_width;
          drop_down_container = 'sidebar_logo_preview_drag_drop';
          field_name = 'client.client_branding_attributes.sidebar_logo';
        }
        else
        {
          preview_container_id = 'email_logo_preview';
          image_height = CONSTANTS.email_logo.file_height;
          image_width = CONSTANTS.email_logo.file_width;
          drop_down_container = 'email_logo_preview_drag_drop';
          field_name = 'client.client_branding_attributes.email_logo';
        }

        this.remove_error(type);
        if( await this.checkFileDimentions(selectedFile, image_height, image_width, type) &&
           this.checkFileSize(selectedFile, type))
        {
            setSelectedFile(selectedFile)
            this.setPreviewImage(selectedFile, preview_container_id)
            this.hideDropdown(drop_down_container);
            this.showPreviewImage(preview_container_id);
            this.setImageData(field_name, selectedFile);
        }
    }

    deselectFile(event, index, setSelectedFile)
    {
        for( let file of selectedFile)
        {
            selectedFile.splice(index,1)
        }
        setSelectedFile(selectedFile)
    }

    checkFileDimentions(selected_file, validationHeight, validationWidth, type)
    {
         var k_this = this;
        let promise = new Promise(function (resolve, reject) {

            let error = type=='brand_logo' ? CONSTANTS.brand_logo.dimension_error_message : (type == 'sidebar_logo' ? CONSTANTS.sidebar_logo.dimension_error_message : CONSTANTS.email_logo.dimension_error_message);
            var reader = new FileReader();
            if(typeof selected_file != 'undefined')
            {
                reader.readAsDataURL(selected_file);
                reader.onload = (event)=>{
                var imageFile = new Image();
                imageFile.src = event.target.result;
                imageFile.onload = (event)=>{
                                        let image_height = event.target.height;
                                        let image_width = event.target.width;
                                        if(image_height < validationHeight || image_width < validationWidth)
                                        {
                                            k_this.set_image_error(type, error);
                                            resolve(false);
                                        }
                                        else
                                        {
                                              resolve(true);
                                        }
                                        }
                                    }
            }
            else
            {
                k_this.remove_error(type);
                resolve(false);
            }

          });
          return promise;
    }

    checkFileSize(selected_file, type)
    {
        const error = type=='brand_logo' ? CONSTANTS.brand_logo.size_error_message : (type == 'sidebar_logo' ? CONSTANTS.sidebar_logo.size_error_message : CONSTANTS.email_logo.size_error_message);
        const maxFileSize = type == 'brand_logo' ? CONSTANTS.brand_logo.file_size : (type == 'sidebar_logo' ? CONSTANTS.sidebar_logo.file_size : CONSTANTS.email_logo.file_size)
        if(selected_file.size/1024 > maxFileSize)
        {
          this.set_image_error(type, error);
          return false;
        }
        else
        {
          return true;
        }
    }

    openHiddenFileUploader(hiddenInputRef)
    {
        hiddenInputRef.current.click();
    }

    formImagesAreValid(values)
    {
        return (values.client.client_branding_attributes?.email_logo?.size > 0 ||
               (typeof values.client.client_branding_attributes?.email_logo == 'string' && values.client.client_branding_attributes?.email_logo != '')) && (values.client.client_branding_attributes?.logo?.size > 0 || (typeof values.client.client_branding_attributes?.logo  == 'string' && values.client.client_branding_attributes?.logo != ''))
    }

    setFormImagesErrors(values)
    {
      let error = 'Required';
      if( typeof values.client.client_branding_attributes?.email_logo?.size == 'undefined')
      {
        this.set_image_error('email_logo', error)
      }
      if( typeof values.client.client_branding_attributes?.logo?.size == 'undefined')
      {
        this.set_image_error('brand_logo', error)
      }
      if( typeof values.client.client_branding_attributes?.sidebar_logo?.size == 'undefined')
      {
        this.set_image_error('sidebar_logo', error)
      }
    }

    set_image_error(type, error)
    {
        if(type == 'brand_logo')
        {
          if(typeof this.formRef.current.status == 'undefined')
          {
            this.formRef.current.setStatus({client:{client_branding_attributes:{logo: error}}});
          }
          else
          {
            this.formRef.current.status.client.client_branding_attributes['logo'] = error;
            this.formRef.current.setStatus(this.formRef.current.status);
          }
        }
        else if(type == 'sidebar_logo')
        {
          if(typeof this.formRef.current.status == 'undefined')
          {
            this.formRef.current.setStatus({client:{client_branding_attributes:{sidebar_logo: error}}});
          }
          else
          {
            this.formRef.current.status.client.client_branding_attributes['sidebar_logo'] = error;
            this.formRef.current.setStatus(this.formRef.current.status);
          }
        }
        else
        {
          if(typeof this.formRef.current.status == 'undefined')
          {
            this.formRef.current.setStatus({client:{client_branding_attributes:{email_logo: error}}});
          }
          else
          {
            this.formRef.current.status.client.client_branding_attributes['email_logo'] = error;
            this.formRef.current.setStatus(this.formRef.current.status);
          }
        }

    }

    remove_error(type)
    {
        if(type == 'brand_logo')
        {
          if(this.formRef.current.error && this.formRef.current.error?.client?.client_branding_attributes?.logo)
          {
            this.formRef.current.error.client.client_branding_attributes.logo = ''
          }
          else  if(this.formRef.current.status && this.formRef.current.status?.client?.client_branding_attributes?.logo)
          {
            this.formRef.current.status.client.client_branding_attributes.logo = ''
          }
        }
        else if(type == 'sidebar_logo')
        {
          if(this.formRef.current.error && this.formRef.current.error?.client?.client_branding_attributes?.sidebar_logo)
          {
            this.formRef.current.error.client.client_branding_attributes.sidebar_logo = ''
          }
          else  if(this.formRef.current.status && this.formRef.current.status?.client?.client_branding_attributes?.sidebar_logo)
          {
            this.formRef.current.status.client.client_branding_attributes.sidebar_logo = ''
          }
        }
        else
        {
          if(this.formRef.current.error && this.formRef.current.error?.client?.client_branding_attributes?.email_logo)
          {
            this.formRef.current.error.client.client_branding_attributes.email_logo = ''
          }
          else  if(this.formRef.current.status && this.formRef.current.status?.client?.client_branding_attributes?.email_logo)
          {
            this.formRef.current.status.client.client_branding_attributes.email_logo = ''
          }
        }
    }

    setPreviewImage(selected_file, preview_container_id)
    {
        var reader = new FileReader();
        reader.readAsDataURL(selected_file);
        reader.onload = (event)=>{
            document.querySelector(`#${preview_container_id}`).src =  event.target.result;
        }
    }

    hideDropdown(dropDownId)
    {
       let drop_down = document.querySelector(`#${dropDownId}`);
       drop_down.style.display = 'none'
    }

    showPreviewImage(previewImageId)
    {
      let drop_down = document.querySelector(`#${previewImageId}`).closest('.logo_preview_container');
      drop_down.style.display = 'block'
    }

    setImageData(name, value)
    {
      this.formRef.current.setFieldValue(name, value);
    }


  dragOver(e)
  {
    e.preventDefault();
  };

  dragEnter(e)
  {

    e.preventDefault();
  };

  dragLeave(e)
  {
    e.preventDefault();
  };

  fileDrop(e)
  {
    e.preventDefault();
    const files = e.dataTransfer.files;
    if (files.length) {
      handleFiles(files);
    }
  };

  setDragDropClass(link)
  {
    if(link?.length > 0)
      {
        return 'hideDragAndDrop'
      }
      else
      {
        return '';
      }
  }

  setPreviewImageClass(link)
  {
      if(link?.length > 0)
      {
        return 'showPreview'
      }
      else
      {
        return '';
      }
  }

  async handleFormSubmit(values, router, t, setButtonPopup, setClientId, setApiError, selectedEmailLogo, selectedBrandLogo, selectedSidebarLogo)
  {
  let result;
  const formData = new FormData();
  // if(this.formImagesAreValid(values))
  // {
  formData.append("client[name]", values.client.name);
  formData.append("client[website]", values.client.website);
  formData.append("client[ai_access]", values.client.ai_access);
  formData.append("client[check_location_validation]", true)
  if(values.client.location_attributes.id) formData.append("client[location_attributes][id]", values.client.location_attributes.id);
  if(values.client.location_attributes.place_id) formData.append("client[location_attributes][place_id]", values.client.location_attributes.place_id);
  formData.append("client[location_attributes][full_address]", values.client.location_attributes.full_address);
  if(values.client.super_account_owner_attributes.id) formData.append("client[super_account_owner_attributes][id]", values.client.super_account_owner_attributes.id);
  if(values.client.super_account_owner_attributes.user_attributes.id) formData.append("client[super_account_owner_attributes][user_attributes][id]", values.client.super_account_owner_attributes.user_attributes.id);
  formData.append("client[super_account_owner_attributes][user_attributes][contact_no]", values.client.super_account_owner_attributes.user_attributes.contact_no);
  formData.append("client[super_account_owner_attributes][user_attributes][email]", values.client.super_account_owner_attributes.user_attributes.email);
  formData.append("client[super_account_owner_attributes][user_attributes][name]", values.client.super_account_owner_attributes.user_attributes.name);

  //client_branding_attributes
  // values.client.client_branding_attributes.id != null ? formData.append("client[client_branding_attributes][id]", values.client.client_branding_attributes.id || {}) :'';
  // typeof selectedEmailLogo == 'undefined' ?  '' : formData.append("client[client_branding_attributes][email_logo]", selectedEmailLogo);
  // typeof selectedBrandLogo == 'undefined' ?  '' : formData.append("client[client_branding_attributes][logo]", selectedBrandLogo);
  // typeof selectedSidebarLogo == 'undefined' ?  '' : formData.append("client[client_branding_attributes][sidebar_logo]", selectedSidebarLogo);
  // formData.append("client[client_branding_attributes][primary_color_hex]", values.client.client_branding_attributes?.primary_color_hex || '');
  // formData.append("client[client_branding_attributes][logo_branding]", values.client.client_branding_attributes?.logo_branding);
  // formData.append("client[client_branding_attributes][sidebar_logo_branding]", values.client.client_branding_attributes?.sidebar_logo_branding);
  // client_branding_attributes


  if(isItUpdateAction())
  {
    const client_id =   new DataFromUrl().getClientId();
    // result = await new Client().updateClient(values, client_id);
    result = await new Client().updateClient(formData, client_id);
  }
  else
  {
    // result = await new Client().createClient(values);
    result = await new Client().createClient(formData);
  }

  setApiError(result.request);
  const status_code = result.status || result.response.status;

  switch (status_code)
  {
    case SUCCESS_REPONSE_CODE:
      const response = result.data;

      if (response.success)
      {
        if(isItUpdateAction())
        {
          var link = REDIRECT.admins.dashboard.clients.integration.replace('$client_id', response.slug);
          nextStep( setButtonPopup, REDIRECT.admins.dashboard.clients.integration.replace('$client_id', response.slug), router)
        }
        else
        {
          setButtonPopup(true);
        }

        setClientId(response.slug);
      }
      else
      {
        console.log(response.error);

      }
      break;

    case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
      if(result.response.data.error.client?.client_branding_attributes?.email_logo?.length > 0)
      {
        let error = result.response.data.error.client.client_branding_attributes.email_logo;
        this.set_image_error('email_logo', error)
      }
      else if(result.response.data.error.client?.client_branding_attributes?.logo?.length > 0)
      {
        let error = result.response.data.error.client.client_branding_attributes.logo;
        this.set_image_error('brand_logo', error)
      }


      if(typeof result.response.data.error === 'string'){
        new CustomToastrAction().setNormalToastr( result.response.data.error, 'error')
      }
      else{
        const responseError = result.response.data.error
        if(responseError.client.full_address){
          responseError.client["location_attributes"] = {}
          responseError.client.location_attributes["full_address"] = responseError.client.full_address
          delete result.response.data.error.client["full_address"]
        }
        return result.response.data.error
      }
      break;
    default: handleOtherResponseCode(status_code, router);
  }
  // }
  // else
  // {
  //     this.setFormImagesErrors(values);
  // }
}

setInitialProps(data)
{
   if(data?.client?.client_branding_attributes)
   {
     data.client.client_branding_attributes['email_logo'] = data.client.client_branding_attributes?.email_logo_url
     data.client.client_branding_attributes['logo'] = data.client.client_branding_attributes?.logo_url
     data.client.client_branding_attributes['sidebar_logo'] = data.client.client_branding_attributes?.sidebar_logo_url
   }

   return data;
}

}
